export const forgotPasswordSuccessPage = () =>
  import("./ForgotPasswordSuccessPage").then((m) => ({
    Component: m.ForgotPasswordSuccessPage,
  }));
